import * as _ from 'lodash';

import { Injectable } from '@angular/core';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { IDeviceSettingsDefaultValueService } from '../../device-settings-default-value.interface';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { ADPolicyState } from 'src/app/constants/ad-policy.constants';
import { PowerService } from 'src/app/services/power/power.service';

@Injectable({
	providedIn: 'root'
})
export class PowerSmartStandbyDefaultValueService implements IDeviceSettingsDefaultValueService {

	constructor(
		private powerService: PowerService,
		private logger: LoggerService) { }

	initialize(adTags: any): void {
		const powerSmartStandBy = _.get(adTags, DeviceSettingsFeatureToggle.PowerSmartStandBy);

		this.logger.info('PowerSmartStandbyService - Initialize', powerSmartStandBy);

		if (powerSmartStandBy === ADPolicyState.ENABLED) {
			this.setSmartStandbySection();
		}
	}

	private async setSmartStandbySection(): Promise<void> {
		try {
			const smartStandbyCapability = await this.powerService.getSmartStandbyCapability();

			this.logger.info('PowerSmartStandbyService - setSmartStandbySection', smartStandbyCapability);

			if (smartStandbyCapability) {
				this.setPowerSmartStandby(false);
			}
		} catch (error) {
			this.logger.error('PowerSmartStandbyService - setSmartStandbySection', error);
		}
	}

	private async setPowerSmartStandby(defaultValue: boolean): Promise<void> {
		try {
			const currentSmartStandByEnabledValue = await this.powerService.getSmartStandbyEnabled();

			this.logger.info('PowerSmartStandbyService - setPowerSmartStandby', currentSmartStandByEnabledValue);

			if (currentSmartStandByEnabledValue !== undefined && currentSmartStandByEnabledValue !== defaultValue) {
				this.powerService.setSmartStandbyEnabled(defaultValue);
			}
		}
		catch (error) {
			this.logger.error('PowerSmartStandbyService - setPowerSmartStandby', error);
		}
	}
}
